import Axios from "axios";
import config from "configs/config";
import getText from "Translator";

const returnError = (err, lang) => {
  console.log(err);
  const data = {
    success: false,
    code: 5001,
    message: getText("generalerror", lang),
  };
  return data;
};

export const createNewpassword = async (lang, authData) => {
  try {
    const url = `${config.apiserver}/auth/createnewpassword/`;
    console.log("ccccc",url);
    const user = await Axios.post(url, authData);
    console.log(user.data);
    return user.data;
  } catch (err) {
    return returnError(err, lang);
  }
};
export const login = async (lang, authData) => {
  try {
    const url = `${config.apiserver}/auth/login/`;
    console.log(url);
    const user = await Axios.post(url, authData);
    return user.data;
  } catch (err) {
    return returnError(err, lang);
  }
};
export const register = async (lang, newUser) => {
  try {
    const url = `${config.apiserver}/auth/register/`;
    const user = await Axios.post(url, newUser);
    return user.data;
  } catch (err) {
    return returnError(err, lang);
  }
};
export const getUser = async (lang, id, token) => {
  try {
    const url = `${config.apiserver}/auth/getuser/${id}`;
    console.log(url);
    const user = await Axios.get(url, {
      headers: {
        "x-access-token": token,
      },
    });
    return user.data;
  } catch (err) {
    return returnError(err, lang);
  }
};

export const activation = async (lang, newData, token) => {
  try {
    const url = `${config.apiserver}/admin/updateuseractivation/`;

    const res = await Axios.put(url, newData, {
      headers: {
        "x-access-token": token,
      },
    });

    return res.data;
  } catch (err) {
    return returnError(err, lang);
  }
};

export const deleteUser = async (lang, id, token) => {
  try {
    const url = `${config.apiserver}/admin/deleteuser/${id}`;
    const responce = await Axios.delete(url, {
      headers: {
        "x-access-token": token,
      },
    });

    return responce.data;
  } catch (err) {
    return returnError(err, lang);
  }
};

export const updateDateMode = async (data, controller) => {
  try {
    const url = `${config.apiserver}/auth/updatedatemode`;
    console.log(url);
    const user = await Axios.post(url, data, {
      headers: {
        "x-access-token": controller.token,
      },
    });
    return user.data;
  } catch (err) {
    return returnError(err, "fa");
  }
};
export const updateLang = async (data, controller) => {
  try {
    const url = `${config.apiserver}/auth/updatelang`;
    const user = await Axios.post(url, data, {
      headers: {
        "x-access-token": controller.token,
      },
    });
    return user.data;
  } catch (err) {
    return returnError(err, "fa");
  }
};
export const storeAccountFavorite = async (data, controller) => {
  try {
    const url = `${config.apiserver}/menu/storeaccountfavorite`;
    const user = await Axios.post(url, data, {
      headers: {
        "x-access-token": controller.token,
      },
    });
    return user.data;
  } catch (err) {
    return returnError(err, "fa");
  }
};
export const getCooperate = async (controller) => {
  try {
    const url = `${config.apiserver}/auth/getcooperate`;
    const user = await Axios.get(url, {
      headers: {
        "x-access-token": controller.token,
      },
    });
    return user.data;
  } catch (err) {
    return returnError(err, "fa");
  }
};
export const registerCooperate = async (newData, controller) => {
  try {
    const url = `${config.apiserver}/auth/registerCooperate`;
    const user = await Axios.post(url, newData, {
      headers: {
        "x-access-token": controller.token,
      },
    });
    return user.data;
  } catch (err) {
    return returnError(err, "fa");
  }
};
export const removeCooperate = async (data, controller) => {
  try {
    const url = `${config.apiserver}/auth/removecooperate`;
    const user = await Axios.post(url, data, {
      headers: {
        "x-access-token": controller.token,
      },
    });
    return user.data;
  } catch (err) {
    return returnError(err, "fa");
  }
};

export const completProfile = async (profile, picture, controller) => {
  try {
    const formData = new FormData();

    formData.append("image", picture);
    formData.append("name", profile.name);
    formData.append("code", profile.code);
    formData.append("age", profile.age);
    formData.append("gender", profile.gender);
    formData.append("speciality", profile.speciality);
    formData.append("city", profile.city);
    formData.append("howToInform", profile.howToInform);
    formData.append("nationality", profile.nationality);
    formData.append("institution", profile.institution);
    const url = `${config.apiserver}/auth/completeprofile/`;
    console.log(url);
    const data = await Axios.post(url, formData, {
      headers: {
        // "Content-Type": "multipart/form-data",
        "x-access-token":
          controller.cooperateToken !== ""
            ? controller.cooperateToken
            : controller.token,
      },
    });
    return data.data;
  } catch (err) {
    return returnError(err, "fa");
  }
};
export const getSpecialities = async (lang) => {
  try {
    const url = `${config.server}general/specialities`;
    const specialities = await Axios.get(url);

    return specialities.data;
  } catch (err) {
    return returnError(err, lang);
  }
};
export const getCountries = async (lang) => {
  try {
    const url = `${config.server}general/countries`;
    const countries = await Axios.get(url);
    return countries.data;
  } catch (err) {
    return returnError(err, lang);
  }
};
export const getProfile = async (controller) => {
  try {
    const url = `${config.apiserver}/auth/getprofile`;
    console.log(url);
    const user = await Axios.get(url, {
      headers: {
        "x-access-token":
          controller.cooperateToken !== ""
            ? controller.cooperateToken
            : controller.token,
      },
    });
    return user.data;
  } catch (err) {
    return returnError(err, "fa");
  }
};

export const changeUserRole = async (lang, newDate, token) => {
  try {
    const url = `${config.apiserver}/admin/upateuserrole/`;
    const user = await Axios.put(url, newDate, {
      headers: {
        "x-access-token": token,
      },
    });
    return user.data;
  } catch (err) {
    return returnError(err, lang);
  }
};

export const changeUserActiveMode = async (lang, id, mode, token) => {
  try {
    const url = `${config.apiserver}/admin/changeuseractivemode/${lang}/${id}/${mode}`;
    const user = await Axios.put(url, null, {
      headers: {
        "x-access-token": token,
      },
    });
    return user.data;
  } catch (err) {
    return returnError(err, lang);
  }
};
export const getPassword = async (lang, id, token) => {
  try {
    const url = `${config.apiserver}/admin/getpassword/${lang}/${id}`;
    const user = await Axios.put(url, null, {
      headers: {
        "x-access-token": token,
      },
    });
    return user.data;
  } catch (err) {
    return returnError(err, lang);
  }
};

export const getUsersList = async (lang, perpage, page, search, token) => {
  try {
    const newData = {
      perpage,
      page,
      search,
    };
    const url = `${config.apiserver}/admin/users/`;

    const user = await Axios.post(url, newData, {
      headers: {
        "x-access-token": token,
      },
    });
    return user.data;
  } catch (err) {
    return returnError(err, lang);
  }
};
export const getUsersChart = async (lang, token) => {
  try {
    const url = `${config.apiserver}/app/userschart/`;

    const user = await Axios.get(url, {
      headers: {
        "x-access-token": token,
      },
    });
    return user.data;
  } catch (err) {
    return returnError(err, lang);
  }
};
export const addUserToGroup = async (lang, newUserGroup, token) => {
  try {
    const url = `${config.apiserver}/admin/addusertogroup/`;
    const result = await Axios.put(url, newUserGroup, {
      headers: {
        "x-access-token": token,
      },
    });
    console.log("00000000", result);
    return result.data;
  } catch (err) {
    return returnError(err, lang);
  }
};
